import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background: ${p => (p.darkMode ? '#f7f3ed' : '#f4f4f4')};
    margin: 0;
    padding: 0;
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export const colours = {
  text: '#161616',
  white: '#fff',
  black: '#595959',
  darkGrey: '#7b7b7b',
  grey: '#8c8c8c',
  borderGrey: '#d9d9d9',
  borderGreyLight: '#f0f0f0', // Used for list item seperators
  lightGrey: '#e5e5e5',
  orange: '#ff612c',
  darkOrange: '#ff8c00', //???
  teal: '#56b3c3',
  lightTeal: '#88c0ca',
  red: '#ff5b5b',
  purple: '#8b57c3',
  gold: '#faad14',
  linkBlue: '#2d9aff',
  lightBlue: '#E6F7FF',
  blue: '#1890FF',
  green: '#198038',
  grants: 'rgba(153, 102, 255, 0.5)',
  publications: 'rgba(75, 192, 192, 0.5)',
  posters: 'rgba(255, 159, 64, 0.5)',
  trials: 'rgba(255, 37, 67, 0.5)',
  researchers: 'rgba(253, 181, 151, 0.5)',
  lightRed: '#FFA39E',
  inlcudeFilter: 'rgba(86, 179, 195, 0.1)',
  excludeFilter: 'rgba(255, 163, 158, 0.15)',
  breakpoint: {
    mobile: '@media only screen and (max-width: 667px)',
    smallTablet: '@media only screen and (max-width: 900px)',
    tablet: '@media only screen and (max-width: 1042px)',
    smallLaptop: '@media only screen and (max-width: 1400px)',
  },
  brands: {
    academia: '#1e3e53',
    linkedin: '#2867b2',
    facebook: '#4267B2',
    google: '#3b7ded',
    twitter: '#1da1f2',
    instagram: '#ee0076',
    researchgate: '#00c4b4',
    hubspot: '#ff7a59',
    salesforce: '#00A1E0',
    dynamics: '#00A1ED',
  },
  infoLightBlue: '#F2F8FB',
  character: {
    primary85: '#000000D9',
    title85: '#000000D9',
    warning: '#FAAD14',
  },
};

export const theme = {
  white: '#fff',
  black: '#595959',
  darkGrey: '#7b7b7b',
  grey: '#8c8c8c',
  borderGrey: '#d9d9d9',
  lightGrey: '#e5e5e5',
  orange: '#ff612c',
  teal: '#56b3c3',
  lightTeal: '#88c0ca',
  red: '#ff5b5b',
  purple: '#8b57c3',
  linkBlue: '#2d9aff',
  lightBlue: '#E6F7FF',
  blue: '#1890FF',
  unfollow: 'rgba(255, 77, 79, 1)',
  unfollowBorder: 'rgba(255, 77, 79, 0.25)',
  grants: 'rgba(153, 102, 255, 0.5)',
  publications: 'rgba(75, 192, 192, 0.5)',
  posters: 'rgba(255, 159, 64, 0.5)',
  trials: 'rgba(255, 37, 67, 0.5)',
  lightRed: '#FFA39E',
  includeFilter: 'rgba(86, 179, 195, 0.1)',
  excludeFilter: 'rgba(255, 163, 158, 0.15)',
  breakpoint: {
    mobile: '@media only screen and (max-width: 667px)',
    smallTablet: '@media only screen and (max-width: 900px)',
    tablet: '@media only screen and (max-width: 1042px)',
    smallLaptop: '@media only screen and (max-width: 1400px)',
  },
  brands: {
    linkedin: '#2867b2',
    facebook: '#4267B2',
    twitter: '#1da1f2',
    instagram: '#ee0076',
    researchgate: '#00c4b4',
  },
};

const getGutter = (width, asInt = false) => {
  if (width <= 667) return asInt ? 4 : '4px';
  if (width <= 1042) return asInt ? 8 : '8px';
  return asInt ? 15 : '15px';
};

const composedTheme = (width, darkMode) => ({
  ...theme,
  gutter: getGutter(width),
  gutterValue: getGutter(width, true),
  darkMode,
});

export default composedTheme;
